export const DNA: string[] = ["openness", "enterprise", "creativity", "care"];
